import React from 'react'
import {
  Paper,
  Box,
  Typography
} from '@mui/material'
import DocumentCover from './DocumentCover'
import DocumentTitle from './DocumentTitle'
import DocumentActions from './DocumentActions'

import './Document.scss'

export default function DocumentCard({document}) {
  return (
    <Paper id="document-card" elevation={10} className="paper-grid-wrapper">
      {/* {error && (
        <Alert severity="error" className="error" onClose={onCloseError}>
          <AlertTitle>Error</AlertTitle>
          {error}
        </Alert>
      )} */}
      <Box className="cover-wrapper">
        <DocumentCover
          cover_id={document.book_info_cover_ids[0]}
        />
      </Box>
      
      <Box className="extension-overlay">
        <Typography variant="caption">
          {document.file_extension.toUpperCase()}
        </Typography>
      </Box>

      <Box className="box-description" mt={2}>
        <DocumentTitle
          authors={document.book_info_authors}
          title={document.book_info_title}
          fallback={document.file_name}
        />
        {/* <DocumentMeta
          id={document.id}
          extension={document.file_extension}
          sizeMB={document.file_size / 1024 / 1024}
        /> */}
      </Box>

      <Box mt={2}>
        <DocumentActions document={document}/>
      </Box>
    </Paper>
  )
}
